import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-retrofit',
  templateUrl: './retrofit.component.html',
  styleUrls: ['./retrofit.component.scss']
})
export class RetrofitComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
